__turbopack_context__.v({
  "accordion": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordion",
  "accordionContent": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordionContent",
  "accordionContentContainer": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordionContentContainer",
  "accordionHeader": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__accordionHeader",
  "attention": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__attention",
  "attention-shake": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__attention-shake",
  "badge": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__badge",
  "badgeRequired": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__badgeRequired",
  "caret": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__caret",
  "counter": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__counter",
  "counterComplete": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__counterComplete",
  "error": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__error",
  "headerContainer": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__headerContainer",
  "subtitle": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__subtitle",
  "title": "ProductConfigurationAccordion-module-scss-module__iQf8Lq__title",
});
